import { useCallback, useEffect } from "react";
import Property1Default1 from "./property1-default1";
import Property1Default from "./property1-default";
import "./project-card.css";

const ProjectCard = () => {
  const onProject2ContainerClick = useCallback(() => {
    window.open("https://dised.in/");
  }, []);

  useEffect(() => {
    const scrollAnimElements = document.querySelectorAll(
      "[data-animate-on-scroll]"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            const targetElement = entry.target;
            targetElement.classList.add("animate");
            observer.unobserve(targetElement);
          }
        }
      },
      {
        threshold: 0.15,
      }
    );

    for (let i = 0; i < scrollAnimElements.length; i++) {
      observer.observe(scrollAnimElements[i]);
    }

    return () => {
      for (let i = 0; i < scrollAnimElements.length; i++) {
        observer.unobserve(scrollAnimElements[i]);
      }
    };
  }, []);
  return (
    <div
      className="frame-group"
      data-scroll-to="frameContainer1"
      data-animate-on-scroll
    >
      <div className="projects-wrapper">
        <div className="projects">Projects</div>
      </div>
      <Property1Default1
        property1DefaultPosition="absolute"
        property1DefaultTop="232px"
        property1DefaultLeft="24px"
        property1DefaultBorderRadius="15px"
      />
      <Property1Default
        property1DefaultPosition="absolute"
        property1DefaultTop="479px"
        property1DefaultLeft="24px"
        property1DefaultBorderRadius="15px"
        property1DefaultCursor="pointer"
        rectangleIconTop="-140px"
        onProject2ContainerClick={onProject2ContainerClick}
      />
    </div>
  );
};

export default ProjectCard;
